export enum ThemeEnum {
    DarkTheme = 'dark-theme',
    LightTheme = 'light-theme'
}